import { render } from "./ConfirmSubmissionDialog.vue?vue&type=template&id=08b3148e"
import script from "./ConfirmSubmissionDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmSubmissionDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__